import { isDevelopmentMode, methods, sendRequest } from "../base";

export const sendPushTokenForDevice = (pushToken) => {
  const device_id = window.localStorage.getItem("device_id");
  return sendRequest(
    isDevelopmentMode()
      ? "/accounts/devices/" + device_id
      : "/trade/current-gold-price/",
    methods.PATCH,
    { push_service_token: pushToken }
  );
};
